module.exports = __webpack_public_path__ + "media/stylesheets/images/logo4-94766acca614013499a73ab2d34d686b.gif";